import React from 'react';
import { Group, Skeleton, Text } from '@landr/maestro';

const Byline = ({
    isLoading,
    byline,
}: {
    isLoading: boolean;
    byline?: string;
}) => {
    if (!byline) {
        return null;
    }

    return isLoading ? (
        <Group.Item>
            <Skeleton
                height="xs"
                width={{ base: '200px', md: '500px' }}
                marginTop="lg"
                marginBottom="sm"
            />

            <Skeleton height="xs" width="100px" marginBottom="xs" />
        </Group.Item>
    ) : (
        <Group.Item>
            <Text
                color="text.medium"
                textStyle="lead"
                fontWeight="normal"
                display="block"
                marginTop="sm"
            >
                {byline}
            </Text>
        </Group.Item>
    );
};

export default Byline;
